import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import Input from '../../../../Input';
import { useGetProcessedValues } from '../../../Hooks/useGetProcessedValues/useGetProcessedValues.hook';
import { getClasses } from '../../../../../Utils/getClasses';
import { ISummaryTableProps } from './SummaryTable/SummaryTable';

interface ISummaryTableFormProps extends ISummaryTableProps {
  hidden: boolean;
  onChange?: (newScores: number[]) => void;
}

export const SummaryTableForm = forwardRef((args: ISummaryTableFormProps, ref: React.Ref<any>) => {
  const { onChange, hidden, start = 0, end = 18, partials = [] } = args;

  const { processedPars, processedGross, processedOriginals } = useGetProcessedValues({
    end,
    partials,
    start
  });

  const readOnlyIndexes = partials.map((p, index) => p.to + index);
  const [values, setValues] = useState([...processedGross]);
  const [defaultValues, setDefaultValues] = useState([...processedGross]);

  useEffect(() => {
    if (JSON.stringify(defaultValues) !== JSON.stringify(processedGross)) {
      setValues([...processedGross]);

      setDefaultValues([...processedGross]);
    }
  }, [processedGross]);

  const onEditScore = (index: number) => (event: any) => {
    const newValues = [...values];

    newValues[index] = event.target.value || '0';

    if (onChange) {
      onChange(
        newValues
          .map(n => Number(n) || 0)
          .filter((_, order: number) => !readOnlyIndexes.includes(order - 1))
      );
    }

    setValues(newValues);
  };

  useImperativeHandle(ref, () => ({
    resetForm(): void {
      const newOriginals = processedOriginals || [];

      if (onChange) {
        onChange(
          newOriginals
            .map(n => Number(n) || 0)
            .filter((_, order: number) => !readOnlyIndexes.includes(order - 1))
        );
      }

      setValues(newOriginals);
    }
  }));

  return (
    <table className={`summary-table summary-table-form ${hidden ? 'hidden' : 'visible'}`}>
      <tbody>
        <tr className="trow">
          <td className="text">
            <div className="value">ORIG</div>
          </td>

          {processedOriginals.map((h, index) => (
            <td
              key={`form-original-${index}`}
              className={`value-wrapper ${getClasses(processedPars, index, h, true)}`}
            >
              <div>
                <div>
                  <div className="value">{!!h && h !== 'null' ? h : '--'}</div>
                </div>
              </div>
            </td>
          ))}
        </tr>

        <tr className="trow">
          <td className="text">
            <div className="value">EDIT</div>
          </td>

          {values.map((h, index: any) => (
            <td key={`score-form-hole-${index}`} className="value-wrapper">
              <div>
                <div>
                  <div className="value">
                    {readOnlyIndexes.includes(index - 1) || (
                      <Input
                        type="number"
                        value={h as any}
                        onChange={onEditScore(index)}
                        label=""
                        inputProps={{ min: 0 }}
                        outlined={true}
                        noIcon={true}
                        disabled={readOnlyIndexes.includes(index - 1)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
});
